import { createAction, props } from '@ngrx/store';

export interface PageContent {
  pageId: string;
  content: any;
}

export const LoadContent = createAction('[Content] Load Content');
export const LoadContentSuccess = createAction(
  '[Content] Load Content Data Success',
  props<{ payload: any }>(),
);
export const LoadContentFail = createAction(
  '[Content] Load Content Fail',
  props<{ payload: any }>(),
);
